import { useMemo } from 'react';
// components
// routes
import { paths } from '@routes/paths';
import { RequiredPerm } from '@routes/permissions';
// styles
import ICONS from '@theme/icons';

import { getClientCountry } from '@utils/helpers';
import {
  Activity,
  DollarSign,
  PieChart,
  Settings,
  SquareTerminal
} from 'lucide-react';

// ----------------------------------------------------------------------

const ROMANIA_MODULES = [
  'home',
  'finance',
  'ads',
  'overview',
  'economics',
  'discount',
  'profile',
  'summary',
  'calendar',
  'budget',
  'growdash academy',
  'analyze my menu',
  'menu suggestion',
  'competitors',
  'popular brands',
  'popular items',
  'item search',
  'analytics',
  'goals',
  'operations settings'
];

// ----------------------------------------------------------------------

export function useNavData() {
  const userCountry = getClientCountry() ?? '';
  const data = useMemo(() => {
    const navItems = [
      // DASHBOARD
      // ----------------------------------------------------------------------
      {
        subheader: 'Pulse',
        icon: Activity,
        items: [
          {
            title: 'Overview',
            path: paths.dashboard.overview,
            icon: ICONS.dashboard,
            permissions: RequiredPerm?.Dashboard
          },
          {
            title: 'Analytics',
            path: paths.dashboard.dashboard,
            icon: ICONS.dashboard,
            permissions: RequiredPerm?.Dashboard,
            hasChildren: true
          },
          {
            title: 'Goals',
            path: paths.aisha.root,
            icon: ICONS.dashboard,
            permissions: RequiredPerm?.Dashboard,
            hasChildren: true
          },
          {
            title: 'Economics',
            path: paths.dashboard.finance,
            icon: ICONS.ecommerce,
            permissions: RequiredPerm?.Finance
          }
        ]
      },
      // CAMPAIGNS
      // ----------------------------------------------------------------------
      {
        subheader: 'Campaigns',
        icon: DollarSign,
        items: [
          {
            title: 'Summary',
            path: paths.campaigns.root,
            icon: ICONS.external,
            permissions: RequiredPerm?.Marketing
          },
          {
            title: 'Ads',
            path: paths.campaigns.ads,
            icon: ICONS.ads,
            permissions: RequiredPerm?.Ads,
            hasChildren: true
          },
          {
            title: 'Discount',
            path: paths.campaigns.discount,
            icon: ICONS.invoice,
            permissions: RequiredPerm?.Discount,
            hasChildren: true
          }
        ]
      },

      // OPERATIONS
      // ----------------------------------------------------------------------
      {
        subheader: 'Operations',
        icon: PieChart,
        items: [
          {
            title: 'Performance',
            path: paths.operations.root,
            icon: ICONS.operations,
            permissions: RequiredPerm?.Operations_Overview
          },
          {
            title: 'Feedback',
            path: paths.operations.reviews_and_rating,
            icon: ICONS.label,
            permissions: RequiredPerm?.ReviewsAndRatings
          }
        ]
      },

      // MANAGEMENT
      // ----------------------------------------------------------------------
      {
        subheader: 'Management',
        icon: SquareTerminal,
        items: [
          {
            title: 'Profile',
            path: paths.management.profile,
            icon: Settings,
            permissions: RequiredPerm?.Profile
          }
        ]
      },
      {
        subheader: 'Resource',
        items: [
          {
            title: 'Growdash Academy',
            path:
              userCountry.toLowerCase() === 'romania'
                ? paths.explore.growthhub
                : paths.explore.growthhub_extended,
            icon: ICONS.academy
          }
        ]
      }
    ];

    if (userCountry.toLowerCase() === 'romania') {
      return navItems
        .map(section => ({
          ...section,
          items: section.items.filter(item =>
            ROMANIA_MODULES.includes(item.title.toLowerCase())
          )
        }))
        .filter(section => section.items.length > 0);
    }

    return navItems;
  }, [userCountry]);

  return data;
}
